/* eslint-disable */
import {  ReactElement, useState } from "react";
import {
  Alert,
  App,
  Button,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Input,
  MenuProps,
  Popconfirm,
  Row,
  Space,
  Spin,
} from "antd";
import type { DatePickerProps } from "antd";
import { InlineField, ThreeLineField } from "./AccountInfo/AccountInfoCard";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import * as React from "react";
import { useStore } from "../../../stores/root-store-context";
import { observer } from "mobx-react-lite";
import dayjs from "dayjs";
import { clone } from "lodash";

import {
  ContactInformation,
  ContactType,
  PhoneData,
  PhoneInputNumber,
} from "./ContactInfo";

const datePickerPlacements: DatePickerProps["builtinPlacements"] = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: { adjustX: 1, adjustY: 1, shiftX: true, shiftY: true },
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: { adjustX: 1, adjustY: 1, shiftX: true, shiftY: true },
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: { adjustX: 0, adjustY: 1, shiftX: true, shiftY: true },
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: { adjustX: 0, adjustY: 1, shiftX: true, shiftY: true },
  },
};

const styles = {
  contactInfoContainer: {
    display: "flex",
    justifyContent: "start",
    flexFlow: "row wrap",
    borderBottom: "1px solid lightgray",
  },
  contactInfoCard: {
    flex: "1 1 300px",
    textAlign: "start" as const,
    alignSelf: "stretch",
    padding: "5px",
    margin: "5px",
  },
  buttonClose: {
    background: "none",
    border: "none",
  },
  phoneContainer: {
    display: "block",
    width: "100%",
    marginBottom: 10,
    marginRight: 10,
    height: 40,
    lineHeight: 40,
  },
  phoneError: {
    backgroundColor: "#fdd6de",
  },
  phoneInput: {
    height: 40,
    lineHeight: 40,
  },
  phoneClose: {
    width: "38px",
    background: "red",
  },
  phoneName: {},
  dateField: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
    marginBottom: 10,
    minHeight: 40,
    background: "#00000005",
    border: "1px solid #d9d9d9",
    borderRadius: 6,
  },
  dateFieldRemove: {
    background: "none",
    border: "none",
    color: "#5a7890",
    flex: "0 0 auto",
  },
  dateFieldPicker: {
    borderRadius: 0,
    flex: "1 1 140px",
    minWidth: 0,
  },
  dateFieldCaption: {
    flex: "1 1 auto",
    minWidth: 0,
    lineHeight: 1.25,
    paddingLeft: 5,
    paddingRight: 8,
    whiteSpace: "break-spaces" as const,
  },
};

const AddContactInfo = observer(
  (props: {
    errorMessage?: string;
    contactInfo: ContactInformation;
    updateAccount: (
      contactData: ContactInformation,
      modifiedString?: string | null
    ) => void;
    deleteAccount: (
      methodId: number,
      type: string,
      deletedValue: string
    ) => void;
    isNonPopconfirm?: boolean;
    ricStyle?: boolean;
    emailInputRef?: (el: HTMLInputElement | null) => void;
  }): ReactElement => {
    const { ricStore, applicationStore } = useStore();

    const { updateAccount, deleteAccount,errorMessage } = props;
    const [localContactInfo, setLocalContactInfo] =
      useState<ContactInformation>(
        clone({ ...props.contactInfo, phones: clone(props.contactInfo.phones) })
      );
    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [isValidemail, setValidEmail] = useState<boolean>(true);
    const { message } = App.useApp();

    const error = (): void => {
      message.open({
        type: "error",
        content: "Error occurred during saving. Please check the entered data.",
      })();
    };

    const onClick: MenuProps["onClick"] = ({ key }) => {
      const type = ContactType[key as keyof typeof ContactType];
      if (
        type === ContactType.HOME ||
        type === ContactType.MOBILE ||
        type === ContactType.WORK
      ) {
        setLocalContactInfo((prev) => {
          return {
            ...prev,
            phones: [
              ...(prev?.phones || []),
              {
                methodId: 0,
                number: "",
                phoneType:
                  key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(),
                type: type,
              },
            ],
          };
        });
      }
      if (type === ContactType.EMAIL) {
        setLocalContactInfo((prev) => {
          return {
            ...prev,
            email: "",
          };
        });
      }
      if (type === ContactType.NOTE) {
        setLocalContactInfo((prev) => {
          return {
            ...prev,
            note: "",
          };
        });
      }
      if (type === ContactType.DATERECEIVED) {
        setLocalContactInfo((prev) => {
          return {
            ...prev,
            dateReceived:"",
          };
        });
      }
      if (type === ContactType.EXPIRATIONDATE) {
        setLocalContactInfo((prev) => {
          return {
            ...prev,
            expirationDate:"",
          };
        });
      }
      if (type === ContactType.BIRTHDATE) {
        setLocalContactInfo((prev) => {
          return {
            ...prev,
            birthdate: "",
          };
        });
      }
    };

    const getOptionContactInformation = (
      contactInfo: ContactInformation
    ): MenuProps => {
      const items: MenuProps["items"] = [];
      if (!contactInfo.email) {
        items.push({
          key: "EMAIL",
          label: "Email",
        });
      }
      if (!contactInfo.note) {
        items.push({
          key: "NOTE",
          label: "Note",
        });
      }
      if (!contactInfo.dateReceived) {
        items.push({
          key: "DATERECEIVED",
          label: "HOPA Date Received",
        });
      }
      if (!contactInfo.expirationDate) {
        items.push({
          key: "EXPIRATIONDATE",
          label: "HOPA Expiration Date",
        });
      }
      if (!contactInfo.birthdate) {
        items.push({
          key: "BIRTHDATE",
          label: "D.O.B.",
        });
      }
console.log(contactInfo.phones,"contactInfo.phones")
      if (!(contactInfo.phones?.length >= 4)) {
        items.push({
          key: "MOBILE",
          label: "Mobile",
        });
        items.push({
          key: "HOME",
          label: "Home",
        });
        items.push({
          key: "WORK",
          label: "Work",
        });
      }
      return { items, onClick };
    };

    function comparePhones(
      newPhones: PhoneData[],
      oldPhones: PhoneData[],
      contactId: string,
      contactName: string
    ): string {
      const messages: string[] = [];
 if (!newPhones || !Array.isArray(newPhones)) return '';
  newPhones?.forEach((newPhone, index) => {
        const oldPhone =
          oldPhones && oldPhones.length > 0 ? oldPhones[index] : undefined;
        if (oldPhone) {
          if (newPhone.number !== oldPhone.number) {
            messages.push(
              `${newPhone.phoneType} modified from '${oldPhone.number}' to '${newPhone.number}' for contact id '${contactId}', ${contactName}`
            );
          }
        } else {
          messages.push(
            `New ${newPhone.phoneType} of '${newPhone.number}' added for contact id '${contactId}', ${contactName}`
          );
        }
      });

      return messages.join("\n");
    }

    function compareObjects(
      newObj: any,
      oldObj: any,
      contactId: any,
      contactName: any
    ): string {
      let changes = [];
      // Nested objects (contactAddress) would print as '[object Object]'; the
      // address and its derived display strings are audited field by field by
      // EditNameAddressForm, and modifiedString is the audit text itself.
      const isAuditable = (key: string) =>
        !["phones", "address", "address2", "modifiedString"].includes(key) &&
        !(newObj[key] !== null && typeof newObj[key] === "object") &&
        !(oldObj[key] !== null && typeof oldObj[key] === "object");
      for (const key in newObj) {
        if (
          isAuditable(key) &&
          Object.prototype.hasOwnProperty.call(newObj, key)
        ) {
          if (oldObj[key] !== newObj[key]) {
            changes.push(
              `${key} modified from '${oldObj[key]}' to '${newObj[key]}'`
            );
          }
        }
      }

      for (const key in oldObj) {
        if (
          isAuditable(key) &&
          Object.prototype.hasOwnProperty.call(oldObj, key) &&
          !Object.prototype.hasOwnProperty.call(newObj, key)
        ) {
          changes.push(`${key} added with value '${oldObj[key]}'`);
        }
      }

      return changes
        .map(
          (change) => `${change} for contact id '${contactId}', ${contactName}`
        )
        .join("\n");
    }

    // One change per line, so entries don't run into each other.
    function joinChanges(...parts: string[]): string | null {
      return parts.filter(Boolean).join("\n") || null;
    }
    const pattern = /\d{3}-\d{3}-\d{4}/;
    React.useEffect(()=>{
ricStore.SetPhoneLength(localContactInfo?.phones)
    },[localContactInfo])
    return (
      <Spin spinning={isUpdating}>
         {/* <h3 >Additional Contact</h3> */}
         <Divider />
         {ricStore.isEditable && (
          <Dropdown
            menu={getOptionContactInformation(localContactInfo)}
            trigger={["click"]}
          >
            <a
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <Space>
                <Button data-testid="ric-add-contact-info-btn" type="primary" shape="circle" icon={<PlusOutlined />} />{" "}
                <span style={{color:'#5c7a93'}}>
                  Click to Add Additional Contact Information
                </span>
              </Space>
            </a>
          </Dropdown>
        )}
         {errorMessage && (
          <Alert
            message={errorMessage}
            type="error"
            // showIcon
            // closable
            // onClose={() => {}}
          />
        )}
        <Row
          style={{marginTop:"20px"}}
          justify={props.ricStyle ? "start" : "space-around"}
          gutter={props.ricStyle ? [32, 20] : [16, 0]}
        >
            {localContactInfo.phones &&
              localContactInfo.phones?.map((el, index, phones) => {
            return  <Col xs={24} md={props.ricStyle ? 12 : 11} key={`${el.methodId}-${index}`}>
                <PhoneInputNumber
                  key={el.methodId}
                  disabled={!ricStore.isEditable}
                  ricStyle={props.ricStyle}
                  phoneData={clone(el)}
                  onChange={(phonedata: PhoneData) => {
                    phones[index] = phonedata;
                    console.log(JSON.parse(JSON.stringify(phones)),phonedata,"phonedataphonedataphonedata");
                    setLocalContactInfo((prev) => {
                      return { ...prev, phones: phones };
                    });
           
                  }}
                  onRemove={(phoneData) => {
                    const newPhones = phones.filter((_, i) => i !== index);
                    const newData: ContactInformation = {
                      ...localContactInfo,
                      phones: newPhones,
                    };
               
                    setLocalContactInfo((prev) => {
                      return { ...prev, phones: newPhones };
                    });
                    updateAccount(newData);
                    deleteAccount(
                      phoneData.methodId,
                      phoneData.phoneType,
                      phoneData.number || ""
                    );
                  }}
                  onBlur={(e) => {
                    const prev =
                      ricStore.contactInformation.find(
                        (el) => el.contactId === localContactInfo.contactId
                      ) || props.contactInfo;

                    const changeMessages = compareObjects(
                      localContactInfo,
                      prev,
                      localContactInfo.contactId,
                      localContactInfo.contactFullName
                    );
                    const changeMessagesPhones = comparePhones(
                      localContactInfo.phones,
                      prev.phones,
                      localContactInfo.contactId,
                      localContactInfo.contactFullName
                    );
                    const modifiedString = joinChanges(changeMessages, changeMessagesPhones);
                    updateAccount(localContactInfo, modifiedString);
                  }}
                  isNonPopconfirm={props.isNonPopconfirm === true}
                />
              </Col>
  })}

            {localContactInfo.note !== null &&
            localContactInfo.note !== undefined ? (
              <Col xs={24} md={props.ricStyle ? 12 : 11}>
                 <Form.Item
        className={props.ricStyle ? "ric-phone-group-item" : undefined}
        name="note"
        rules={[{ required: true, message: 'Please input!' }]}
      >
                {(() => {
                  const noteRemoveButton = (
                    <Button
                      disabled={!ricStore.isEditable}
                      className={props.ricStyle ? "ric-phone-group__remove" : undefined}
                      style={{ background: "none", border: "none", color: "#5a7890" }}
                      onClick={
                        props.isNonPopconfirm
                          ? async () => {
                              const newData: ContactInformation = {
                                ...localContactInfo,
                                note: null,
                              };
                              setLocalContactInfo(newData);
                              updateAccount(newData);
                            }
                          : undefined
                      }
                      icon={<CloseOutlined disabled={!ricStore.isEditable} />}
                    />
                  );
                  const noteRemoveControl = !props.isNonPopconfirm ? (
                    <Popconfirm
                      rootClassName={props.ricStyle ? "ric-modal" : undefined}
                      title="DELETE CONTACT INFORMATION?"
                      description={
                        <div className="ric-confirm-text">
                          Please confirm you'd like to delete this contact
                          information.
                        </div>
                      }
                      okText="Delete"
                      cancelText="Cancel"
                      onConfirm={async () => {
                        const newData: ContactInformation = {
                          ...localContactInfo,
                          note:null,
                        };
                        setLocalContactInfo(newData);
                        updateAccount(newData);
                      }}
                    >
                      {noteRemoveButton}
                    </Popconfirm>
                  ) : (
                    noteRemoveButton
                  );
                  const noteOnChange = (e) => {
                    setLocalContactInfo((prev) => {
                      return { ...prev, note: e.target.value };
                    });
                  };
                  const noteOnBlur = (e) => {
                    const changeMessages = compareObjects(
                      localContactInfo,
                      props.contactInfo,
                      localContactInfo.contactId,
                      localContactInfo.contactFullName
                    );
                    const changeMessagesPhones = comparePhones(
                      localContactInfo.phones,
                      props.contactInfo.phones,
                      localContactInfo.contactId,
                      localContactInfo.contactFullName
                    );
                    const modifiedString = joinChanges(changeMessages, changeMessagesPhones);
                    updateAccount(localContactInfo, modifiedString);
                  };
                  return props.ricStyle ? (
                    <div className="ric-phone-group">
                      {noteRemoveControl}
                      <Input
                        id="note"
                        className="ric-phone-group__input"
                        disabled={!ricStore.isEditable}
                        value={localContactInfo.note}
                        onChange={noteOnChange}
                        onBlur={noteOnBlur}
                        placeholder={"Please enter text"}
                      />
                      <span className="ric-phone-group__type">Note</span>
                    </div>
                  ) : (
                    <Input
                      id="note"
                      style={styles.phoneContainer}
                      styles={{ input: styles.phoneInput }}
                      disabled={!ricStore.isEditable}
                      addonBefore={noteRemoveControl}
                      value={localContactInfo.note}
                      onChange={noteOnChange}
                      onBlur={noteOnBlur}
                      addonAfter={"Note"}
                      placeholder={"Please enter text"}
                    />
                  );
                })()}
                </Form.Item></Col>
            ) : (
              <></>
            )}
         
        
            {localContactInfo.email !== null &&
            localContactInfo.email !== undefined ? (
              <Col xs={24} md={props.ricStyle ? 12 : 11}>
                      <Form.Item
   className={props.ricStyle ? "ric-phone-group-item" : undefined}
   name="email"
   rules={[{ required: true, message: 'Please enter email address' }]}
 >
                {(() => {
                  const emailRemoveButton = (
                    <Button
                      disabled={!ricStore.isEditable}
                      className={props.ricStyle ? "ric-phone-group__remove" : undefined}
                      style={{ background: "none", border: "none", color: "#5a7890" }}
                      onClick={
                        props.isNonPopconfirm
                          ? async () => {
                              const newData: ContactInformation = {
                                ...localContactInfo,
                                email: null,
                                emailMethodId: null,
                              };
                              setLocalContactInfo(newData);
                              updateAccount(newData);
                            }
                          : undefined
                      }
                      icon={<CloseOutlined disabled={!ricStore.isEditable} />}
                    />
                  );
                  const emailRemoveControl = !props.isNonPopconfirm ? (
                    <Popconfirm
                      rootClassName={props.ricStyle ? "ric-modal" : undefined}
                      title="DELETE CONTACT INFORMATION?"
                      description={
                        <div className="ric-confirm-text">
                          Please confirm you'd like to delete this contact
                          information.
                        </div>
                      }
                      okText="Delete"
                      cancelText="Cancel"
                      onConfirm={async () => {
                        const newData: ContactInformation = {
                          ...localContactInfo,
                          email: null,
                          emailMethodId: null,
                          isDeleted : true
                        };
                        setLocalContactInfo(newData);
                        updateAccount(newData);
                      }}
                    >
                      {emailRemoveButton}
                    </Popconfirm>
                  ) : (
                    emailRemoveButton
                  );
                  const emailOnChange = (e) => {
                    setLocalContactInfo((prev) => {
                      return { ...prev, email: e.target.value };
                    });
                    setValidEmail(e.target.checkValidity());
                  };
                  const emailOnBlur = (e) => {
                    const changeMessages = compareObjects(
                      localContactInfo,
                      props.contactInfo,
                      localContactInfo.contactId,
                      localContactInfo.contactFullName
                    );
                    const changeMessagesPhones = comparePhones(
                      localContactInfo.phones,
                      props.contactInfo.phones,
                      localContactInfo.contactId,
                      localContactInfo.contactFullName
                    );
                    const modifiedString = joinChanges(changeMessages, changeMessagesPhones);
                        
                    updateAccount(localContactInfo, modifiedString);
                  };
                  return props.ricStyle ? (
                    <div className="ric-phone-group">
                      {emailRemoveControl}
                      <Input
                        id="email"
                        className="ric-phone-group__input"
                        type="email"
                        pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                        status={!isValidemail ? "error" : ""}
                        disabled={!ricStore.isEditable}
                        value={localContactInfo.email}
                        onChange={emailOnChange}
                        onBlur={emailOnBlur}
                        placeholder={"Please enter valid email address"}
                        ref={(instance): void =>
                          props.emailInputRef?.(instance?.input ?? null)
                        }
                      />
                      <span className="ric-phone-group__type">Email</span>
                    </div>
                  ) : (
                    <Input
                      id="email"
                      style={styles.phoneContainer}
                      styles={{ input: styles.phoneInput }}
                      type="email"
                      pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                      status={!isValidemail ? "error" : ""}
                      disabled={!ricStore.isEditable}
                      addonBefore={emailRemoveControl}
                      value={localContactInfo.email}
                      onChange={emailOnChange}
                      onBlur={emailOnBlur}
                      addonAfter={"Email"}
                      placeholder={"Please enter valid email address"}
                      ref={(instance): void =>
                        props.emailInputRef?.(instance?.input ?? null)
                      }
                    />
                  );
                })()}
                </Form.Item></Col>
            ) : (
              <></>
            )}
           
              {localContactInfo.dateReceived !== null &&
              localContactInfo.dateReceived !== undefined ? (
                <Col xs={24} md={12}>
                {(() => {
                  const dateReceivedRemoveButton = (
                    <Button
                      disabled={!ricStore.isEditable}
                      className={props.ricStyle ? "ric-phone-group__remove" : undefined}
                      style={
                        props.ricStyle
                          ? { background: "none", border: "none", color: "#5a7890" }
                          : styles.dateFieldRemove
                      }
                      onClick={
                        props.isNonPopconfirm
                          ? async () => {
                              const newData: ContactInformation = {
                                ...localContactInfo,
                                dateReceived: null,
                              };
                              setLocalContactInfo(newData);
                              updateAccount(newData);
                            }
                          : undefined
                      }
                      icon={<CloseOutlined disabled={!ricStore.isEditable} />}
                    />
                  );
                  const dateReceivedRemoveControl = !props.isNonPopconfirm ? (
                    <Popconfirm
                      rootClassName={props.ricStyle ? "ric-modal" : undefined}
                      title="DELETE CONTACT INFORMATION?"
                      description={
                        <div className="ric-confirm-text">
                          Please confirm you'd like to delete this contact
                          information.
                        </div>
                      }
                      okText="Delete"
                      cancelText="Cancel"
                      onConfirm={async () => {
                        const newData: ContactInformation = {
                          ...localContactInfo,
                          dateReceived: null,
                        };
                        setLocalContactInfo(newData);
                        updateAccount(newData);
                      }}
                    >
                      {dateReceivedRemoveButton}
                    </Popconfirm>
                  ) : (
                    dateReceivedRemoveButton
                  );
                  const dateReceivedPicker = (
                    <DatePicker
                      className={props.ricStyle ? "ric-phone-group__input" : undefined}
                      builtinPlacements={datePickerPlacements}
                      onChange={async (date) => {
                        const newData: ContactInformation = {
                          ...localContactInfo,
                          dateReceived: date.format("M/D/YYYY"),
                        };
                        setLocalContactInfo(newData);
                        const changeMessages = compareObjects(
                          localContactInfo,
                          props.contactInfo,
                          localContactInfo.contactId,
                          localContactInfo.contactFullName
                        );
                        const changeMessagesPhones = comparePhones(
                          localContactInfo.phones,
                          props.contactInfo.phones,
                          localContactInfo.contactId,
                          localContactInfo.contactFullName
                        );
                        const modifiedString = joinChanges(changeMessages, changeMessagesPhones);
                        updateAccount(newData, modifiedString);
                      }}
                      defaultValue={
                              localContactInfo?.dateReceived
                                ? dayjs(localContactInfo?.dateReceived)
                                  : null
                             }
                      disabledDate={(current) => {
                         const expiration = localContactInfo.expirationDate
                          ? dayjs(localContactInfo.expirationDate)?.startOf("day")
                           : null;
                           if (!expiration) return false;
                           const cur = current?.clone()?.startOf("day");
                           return cur?.isSame(expiration) || cur?.isAfter(expiration);
                          }}
                      title="HOPA Date Received"
                      style={props.ricStyle ? undefined : styles.dateFieldPicker}
                      format={"M/D/YYYY"}
                    />
                  );
                  return props.ricStyle ? (
                    <div className="ric-phone-group">
                      {dateReceivedRemoveControl}
                      {dateReceivedPicker}
                      <span className="ric-phone-group__type">HOPA Date Received</span>
                    </div>
                  ) : (
                    <div style={styles.dateField}>
                      {dateReceivedRemoveControl}
                      {dateReceivedPicker}
                      <span color="#000000" style={styles.dateFieldCaption}>
                        HOPA Date Received
                      </span>
                    </div>
                  );
                })()}
                </Col>
              ) : (
                <></>
              )}
           
           <Col xs={24} md={12}>
              {localContactInfo.expirationDate !== null &&
              localContactInfo.expirationDate !== undefined ? (
                (() => {
                  const expirationRemoveButton = (
                    <Button
                      disabled={!ricStore.isEditable}
                      className={props.ricStyle ? "ric-phone-group__remove" : undefined}
                      style={
                        props.ricStyle
                          ? { background: "none", border: "none", color: "#5a7890" }
                          : styles.dateFieldRemove
                      }
                      onClick={
                        props.isNonPopconfirm
                          ? async () => {
                              const newData: ContactInformation = {
                                ...localContactInfo,
                                expirationDate: null,
                              };
                              setLocalContactInfo(newData);
                              updateAccount(newData);
                            }
                          : undefined
                      }
                      icon={<CloseOutlined disabled={!ricStore.isEditable} />}
                    />
                  );
                  const expirationRemoveControl = !props.isNonPopconfirm ? (
                    <Popconfirm
                      rootClassName={props.ricStyle ? "ric-modal" : undefined}
                      title="DELETE CONTACT INFORMATION?"
                      description={
                        <div className="ric-confirm-text">
                          Please confirm you'd like to delete this contact
                          information.
                        </div>
                      }
                      okText="Delete"
                      cancelText="Cancel"
                      onConfirm={async () => {
                        const newData: ContactInformation = {
                          ...localContactInfo,
                          expirationDate: null,
                        };
                        setLocalContactInfo(newData);
                        updateAccount(newData);
                      }}
                    >
                      {expirationRemoveButton}
                    </Popconfirm>
                  ) : (
                    expirationRemoveButton
                  );
                  const expirationPicker = (
                    <DatePicker
                      className={props.ricStyle ? "ric-phone-group__input" : undefined}
                      builtinPlacements={datePickerPlacements}
                      onChange={async (date) => {
                        const newData: ContactInformation = {
                          ...localContactInfo,
                          expirationDate: date.format("M/D/YYYY"),
                        };
                        setLocalContactInfo(newData);
                        const changeMessages = compareObjects(
                          localContactInfo,
                          props.contactInfo,
                          localContactInfo.contactId,
                          localContactInfo.contactFullName
                        );
                        const changeMessagesPhones = comparePhones(
                          localContactInfo.phones,
                          props.contactInfo.phones,
                          localContactInfo.contactId,
                          localContactInfo.contactFullName
                        );
                        const modifiedString = joinChanges(changeMessages, changeMessagesPhones);
                        updateAccount(newData, modifiedString);
                      }}
                      disabledDate={(current) => {
                      const received = localContactInfo.dateReceived
                      ? dayjs(localContactInfo.dateReceived)?.startOf("day")
                       : null;
                        if (!received) return false;
                         const cur = current?.clone()?.startOf("day");
                          return cur?.isSame(received) || cur?.isBefore(received);
                        }}
                       defaultValue={
                        localContactInfo.expirationDate
                        ? dayjs(localContactInfo.expirationDate)
                        : null
                      }
                      title="HOPA Expiration Date"
                      style={props.ricStyle ? undefined : styles.dateFieldPicker}
                      format={"M/D/YYYY"}
                    />
                  );
                  return props.ricStyle ? (
                    <div className="ric-phone-group">
                      {expirationRemoveControl}
                      {expirationPicker}
                      <span className="ric-phone-group__type">HOPA Expiration Date</span>
                    </div>
                  ) : (
                    <div style={styles.dateField}>
                      {expirationRemoveControl}
                      {expirationPicker}
                      <span color="#000000" style={styles.dateFieldCaption}>
                        HOPA Expiration Date
                      </span>
                    </div>
                  );
                })()
              ) : (
                <></>
              )}
            </Col>
            <Col xs={24} md={12}>
              {localContactInfo.birthdate !== null &&
              localContactInfo.birthdate !== undefined ? (
                (() => {
                  const birthdateRemoveButton = (
                    <Button
                      disabled={!ricStore.isEditable}
                      className={props.ricStyle ? "ric-phone-group__remove" : undefined}
                      style={
                        props.ricStyle
                          ? { background: "none", border: "none", color: "#5a7890" }
                          : styles.dateFieldRemove
                      }
                      onClick={
                        props.isNonPopconfirm
                          ? async () => {
                              const newData: ContactInformation = {
                                ...localContactInfo,
                                birthdate: null,
                              };
                              setLocalContactInfo(newData);
                              updateAccount(newData);
                            }
                          : undefined
                      }
                      icon={<CloseOutlined disabled={!ricStore.isEditable} />}
                    />
                  );
                  const birthdateRemoveControl = !props.isNonPopconfirm ? (
                    <Popconfirm
                      rootClassName={props.ricStyle ? "ric-modal" : undefined}
                      title="DELETE CONTACT INFORMATION?"
                      description={
                        <div className="ric-confirm-text">
                          Please confirm you'd like to delete this contact
                          information.
                        </div>
                      }
                      okText="Delete"
                      cancelText="Cancel"
                      onConfirm={async () => {
                        const newData: ContactInformation = {
                          ...localContactInfo,
                          birthdate: null,
                        };
                        setLocalContactInfo(newData);
                        updateAccount(newData);
                      }}
                    >
                      {birthdateRemoveButton}
                    </Popconfirm>
                  ) : (
                    birthdateRemoveButton
                  );
                  const birthdatePicker = (
                    <DatePicker
                      className={props.ricStyle ? "ric-phone-group__input" : undefined}
                      builtinPlacements={datePickerPlacements}
                       defaultValue={
    localContactInfo?.birthdate
      ? dayjs(localContactInfo?.birthdate)
      : null
  }
                      disabledDate={(current) => {
    return current && current >= dayjs()?.startOf("day");
  }}
                      onChange={async (date) => {
                        const newData: ContactInformation = {
                          ...localContactInfo,
                          birthdate: date.format("M/D/YYYY"),
                        };
                        setLocalContactInfo(newData);
                        const changeMessages = compareObjects(
                          localContactInfo,
                          props.contactInfo,
                          localContactInfo.contactId,
                          localContactInfo.contactFullName
                        );
                        const changeMessagesPhones = comparePhones(
                          localContactInfo.phones,
                          props.contactInfo.phones,
                          localContactInfo.contactId,
                          localContactInfo.contactFullName
                        );
                        const modifiedString = joinChanges(changeMessages, changeMessagesPhones);
                        updateAccount(newData, modifiedString);
                      }}
                      title="D.O.B."
                      style={props.ricStyle ? undefined : styles.dateFieldPicker}
                      format={"M/D/YYYY"}
                    />
                  );
                  return props.ricStyle ? (
                    <div className="ric-phone-group">
                      {birthdateRemoveControl}
                      {birthdatePicker}
                      <span className="ric-phone-group__type">D.O.B.</span>
                    </div>
                  ) : (
                    <div style={styles.dateField}>
                      {birthdateRemoveControl}
                      {birthdatePicker}
                      <span color="#000000" style={styles.dateFieldCaption}>
                        D.O.B.
                      </span>
                    </div>
                  );
                })()
              ) : (
                <></>
              )}
            </Col>
     
        </Row>
       
      </Spin>
    );
  }
);
export default AddContactInfo;
